module.exports = __webpack_public_path__ + "static/media/alimentation.8bebdea7.jpg";